import { action, computed, observable, makeAutoObservable } from 'mobx';

export class FormConcept<T> {
    @observable private inputValue: T | null = null;

    constructor(private readonly getModelValue: () => T) {
        makeAutoObservable(this);
    }

    @action public setValue = (value: T | null): void => {
        this.inputValue = value;
    };

    @computed public get value(): T {
        if (this.inputValue !== null) {
            return this.inputValue;
        }
        return this.getModelValue();
    }

    @computed public get wasChange(): boolean {
        return this.inputValue !== null && this.inputValue !== this.getModelValue();
    }

    @action public reset = (): void => {
        this.inputValue = null;
    };
}
